<template>
  <div v-if="!isTempUser">

    <template v-if="isCareerHome">
      <nav class="layout-footer footer stream_footer bg-footer-theme">
        <div class="container-fluid d-flex flex-wrap justify-content-between">

          <b-link :to="{ name: returnTo, params: params, query: query}" class="col-12 footer-link">
            <span class="ic-arrow-left2"></span>
            {{pageTitle}}
          </b-link>

        </div>
      </nav>
    </template>

    <template v-else>
      <nav class="layout-footer footer stream_footer bg-footer-theme sm_back_btn">
        <div class="container-fluid d-flex flex-wrap justify-content-between">

          <div class="back_btn">
            <b-link :to="{ name: returnTo, params: params, query: query}" class="footer-link">
              <span class="ic-arrow-left2"></span>
              <span class="btn_txt">back</span>
            </b-link>
          </div>

          <div class="footer_links_with_back_btn">
            <span class="footer_txt">{{pageTitle}}</span>
          </div>

        </div>
      </nav>
    </template>

  </div>
</template>

<script>
  import { mapState } from 'vuex'
  
  export default {
    name: 'careerFooterNavbar',
    props: ['pageTitle', 'returnTo', 'params'],
    computed: {
      ...mapState({
        'isTempUser': state => state.login.tempUser
      }),
      isCareerHome () {
        return (this.$route.name === 'careerHome')
      },
      query () {
        if (this.$route.query && this.$route.query.returnTo === 'careerPrograms') {
          return (this.$route.name === 'careerPrograms') ? {} : this.$route.query
        }
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app/misc/components/CareerFooterNavbar.vue